import { useMutation } from '@tanstack/react-query';
import { updateUserAllTasksHideHabits } from 'shared/services/backend-api';

export const useUpdateHideHabitsAllTasksMutation = () =>
  useMutation({
    mutationFn: async (hideHabits: boolean) =>
      updateUserAllTasksHideHabits(hideHabits),
  });
